<template>
    <div>
        <vx-card title="Financial Summary" titleIcon="ActivityIcon" ref="filterCard">
            <vx-card class="p-4" noShadow>
                <div class="vx-row">
                    <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                        <label class="text-sm opacity-100 text-bold">Interval</label>
                    
                            
                            <v-select :clearable="false" placeholder="" v-model="range_obj" :options="rangeGenerator(['This Month','This Quarter','This Year','Choose Your Own Dates'])" label="label"
                                @input="onChangeRange()" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                       
                    </div>
                    <div v-if="range_obj.value === 'own_dates'" class="vx-col md:w-1/3 sm:w-1/3 w-full">
                        <label class="text-sm opacity-100 text-bold">Date From</label>
                        <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                            v-model="filters['from']" placeholder="Choose Date" />
                        <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                            placeholder="Choose Date" />
                    </div>
                    <div  v-if="range_obj.value === 'own_dates'" class="vx-col md:w-1/3 sm:w-1/3 w-full">
                        <label class="text-sm opacity-100 text-bold">Date To</label>
                        <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                            v-model="filters['to']" placeholder="Choose Date" />
                        <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                            placeholder="Choose Date" />
                    </div>
                </div>
                <div class="vx-row mt-8">
                    <div class="vx-col w-full flex">
                        <h4 class="text-primary mr-4">Total sales in selected period:</h4> <h4>{{ total_sales_value }} {{ account_currency }}</h4>
                    </div>
                </div>
            </vx-card>

            <vue-apex-charts ref="lineApexChart" type="line" height="350" :options="lineChartSimple.chartOptions"
                :series="lineChartSimple.series"></vue-apex-charts>


        </vx-card>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const CrmRepository = RepositoryFactory.get('crm');
import Filter from '@/mixins/filter';
import vSelect from 'vue-select'
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import VueApexCharts from 'vue-apexcharts'
import Utils from "@/mixins/Utils";

export default {
    name: 'CustomerCrmSnapshotSummaryReport',
    data() {
        return {
            customerId: null,
            filters: {
                from: '',
                to: '',
                interval: 'monthly'
            },
            range_obj: {
                value: null
            },
            total_sales_value: 0,
            lineChartSimple: {
                series: [],
                chartOptions: {
                    chart: {
                        height: 350,
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth',
                        dashArray: 0,
                        width: 5
                    },
                    title: {
                        text: '',
                        align: 'left'
                    },
                    grid: {
                        show: true,
                        borderColor: '#e7e7e7',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                    },
                    legend: {
                        show: true
                    },
                    markers: {
                        size: 5,
                        hover: {
                            size: 8
                        }
                    },
                    xaxis: {
                        categories: [],
                        title: {
                            text: 'Time'
                        },
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current'
                            }
                        },
                        axisTicks: {
                            show: false
                        },
                        axisBorder: {
                            show: false
                        }
                    },
                    yaxis: {
                        title: {
                            text: `Order Value (${this.account_currency})`
                        },
                        tickAmount: 5,
                        labels: {
                            style: {
                                cssClass: 'text-black fill-current'
                            },
                            formatter: (val) => {
                                return `${val}`
                            }
                        }
                    },
                    tooltip: {
                        x: { show: true }
                    }
                }
            },
        }
    },
    props: {
        account_currency: {
            default: 'GBP'
        }
    },
    components: {
        'v-select': vSelect,
        flatPickr,
        VueApexCharts,
    },
    mixins: [Filter, Utils],
    async mounted() {
        this.customerId = this.$route.params.id
        const ranges = this.rangeGenerator(['This Month','This Quarter','This Year','Choose Your Own Dates'])
        this.range_obj = ranges.find(r => r.label === 'This Month')
        await this.fetchFinanicialSummary()
    },
    methods: {
        async fetchFinanicialSummary() {
            try {
                const { data } = await CrmRepository.getSnapshotFinancialSummary(this.customerId, `from=${this.filters.from}&to=${this.filters.to}&interval=${this.filters.interval}`)
                const data_obj = {
                    name: 'Orders value',
                    data: data.data.map((x) => x.value)
                }
                this.total_sales_value = Number(data.data.map((x) => x.value).reduce((a, b) => a + Number(b), 0)).toFixed(2)
                const categories = data.data.map((x) => x.label)
                this.$refs.lineApexChart.updateOptions({
                    series: [data_obj],
                    xaxis: { categories: categories },
                })
            } catch (error) {

            }
        },
        filterQueryUpdate() {
            this.fetchFinanicialSummary()
        },

        async onChangeRange() {
            if (this.range_obj.value !== 'own_dates') {
                let arr = this.range_obj.value.split(' to ')
                this.filters.from = arr[0]
                this.filters.to = arr[1]
                await this.fetchFinanicialSummary()
            }
        },
    },
    computed: {
        totalSalesValue: () => {
            return 0
        }
    }
}
</script>
<style lang="">
    
</style>